import { Content } from "@iventis/translations/content/typed-content";
import { toast } from "@iventis/toasts/src/toast";
import { translate } from "@iventis/translations/translation";
import { IventisTableData } from "../types/data-table.types";
import { DataTableOperations, QueueContext } from "../lib/data-table-machine";

export const toastSuccess = (queueContext: QueueContext) => {
    let message = "";
    const { operation } = queueContext;
    switch (operation) {
        case DataTableOperations.Edit: {
            message = translate(Content.table.toasts.edit_success);
            break;
        }
        case DataTableOperations.Insert: {
            message = translate(Content.table.toasts.insert_success, { type: queueContext.node.data.type?.name });
            break;
        }
        case DataTableOperations.Delete: {
            message = translate(Content.table.toasts.delete_success);
            break;
        }
        default:
            break;
    }
    toast.success(
        {
            title: translate(Content.common.success),
            message,
        },
        { autoHideDuration: 5000 }
    );
};

export const toastError = <TData extends IventisTableData = IventisTableData>(queueContext: QueueContext<TData>, callBack?: () => void) => {
    let message = "";
    const { operation } = queueContext;
    switch (operation) {
        case DataTableOperations.Edit: {
            message = translate(Content.table.toasts.edit_error);
            break;
        }
        case DataTableOperations.Insert: {
            message = translate(Content.table.toasts.insert_error);
            break;
        }
        case DataTableOperations.Delete: {
            message = translate(Content.table.toasts.delete_error);
            break;
        }
        default:
            break;
    }
    toast.error(
        {
            title: translate(Content.errors.error),
            message,
            button: { label: translate(Content.table.toasts.refresh_cells) },
            onClick: callBack,
        },

        { autoHideDuration: 5000 }
    );
};
